<template>
  <font-awesome-icon icon="fa-solid fa-dashboard" />
</template>
